// This is a top level component for all routes component and we should put styles here that will be used throughout all route components

import styled from 'styled-components';

export const RouteComponentsContainer = styled.div`
  /* add styles here */
`;
